module.exports = __webpack_public_path__ + "img/mind_skeleton_time_9.b34708d1.png";